import React from 'react';
import '../../App.css';
import { Link } from 'react-router-dom';

function Question3() {
    return (
        <div className="FAQ-container" >
          <h1 className="FAQ-title" style={{marginTop: '100px'}}>Frequently Asked Questions</h1>
          <p><span className="faq-titles" ><strong><Link style={{textDecoration: 'none',  color: 'rgb(255, 4, 58)'}} to="/faq">⬅ Go back to the FAQ page.</Link></strong></span></p>
          <div className="FAQ-questions" style={{maxWidth: '700px'}}>  
            <h2>Why can I reset only once every 24 hours my network?</h2>
            <p>
            The reason for that is to avoid account sharing, and to keep the network safe and secure.
            Sharing your account is against our terms of service and can result in a permanent ban.
            </p>
          </div>
        </div>
      );
    }

export default Question3;